const _version = "2.9.3"
function version() {
    return _version;
}
export default version
